/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
/**
 * HoliPowder.js
 * Vibrant powder-colour (Holi) bursts that float over your page.
 * Content stays readable. Runs 10s per session.
 *
 * Usage: <script src="oil-splash.js"></script>
 */

(function () {
  const SESSION_KEY = 'holiPowderPlayed';
  const DURATION_MS = 6000;

  if (sessionStorage.getItem(SESSION_KEY)) return;
  sessionStorage.setItem(SESSION_KEY, '1');

  const canvas = document.createElement('canvas');
  const ctx    = canvas.getContext('2d');

  Object.assign(canvas.style, {
    position:      'fixed',
    top:           '0',
    left:          '0',
    width:         '100vw',
    height:        '100vh',
    zIndex:        '999999',
    pointerEvents: 'none',
    opacity:       '1',
    transition:    'opacity 1.8s ease',
  });

  document.body.appendChild(canvas);

  function resize() {
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  /* ── Vivid powder colours ── */
  const COLORS = [
    '#FF0080', '#FF6B00', '#FFD700',
    '#00E676', '#00B0FF', '#D500F9',
    '#FF3D00', '#76FF03', '#F50057',
    '#00E5FF', '#FFEA00', '#E040FB',
  ];

  function hexRGB(hex) {
    return [
      parseInt(hex.slice(1,3),16),
      parseInt(hex.slice(3,5),16),
      parseInt(hex.slice(5,7),16),
    ];
  }

  /* ─────────────────────────────────────────
     PowderBurst — chalky expanding cloud
  ───────────────────────────────────────── */
  class PowderBurst {
    constructor() { this.init(); }

    init() {
      this.x      = Math.random() * canvas.width;
      this.y      = Math.random() * canvas.height;
      this.color  = COLORS[Math.floor(Math.random() * COLORS.length)];
      this.rgb    = hexRGB(this.color);

      // size: medium — visible but not covering whole page
      this.maxR   = 35 + Math.random() * 55;  // 35–90 px
      this.r      = 0;
      this.speed  = 1.2 + Math.random() * 2;

      // powder alpha — visible like chalk dust
      this.alpha  = 0.38 + Math.random() * 0.22;  // 0.38–0.60
      this.life   = 1.0;
      this.decay  = 0.006 + Math.random() * 0.008;

      // powder particles (tiny floating dots)
      this.particles = Array.from({ length: 18 + Math.floor(Math.random() * 18) }, () => {
        const angle = Math.random() * Math.PI * 2;
        const dist  = this.maxR * (0.3 + Math.random() * 0.9);
        return {
          angle, dist,
          r:     1 + Math.random() * 3.5,
          alpha: 0.25 + Math.random() * 0.45,
          drift: (Math.random() - 0.5) * 0.4,  // slow horizontal float
          rise:  -(0.2 + Math.random() * 0.5),  // powder rises upward
          ox: 0, oy: 0,
        };
      });
    }

    update() {
      if (this.r < this.maxR) this.r += this.speed;
      if (this.r >= this.maxR) this.life -= this.decay;
      this.particles.forEach(p => {
        p.ox += p.drift;
        p.oy += p.rise;
      });
    }

    draw() {
      if (this.life <= 0) return;
      const progress = Math.min(1, this.r / this.maxR);
      const a = this.alpha * this.life;
      const [r, g, b] = this.rgb;
      ctx.save();

      // ── Core cloud: 3 layered soft circles (chalky look) ──
      for (let layer = 0; layer < 3; layer++) {
        const lr  = this.r * (1 - layer * 0.18);
        const la  = a * (0.55 - layer * 0.12);
        const grad = ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, lr);
        grad.addColorStop(0,   `rgba(${r},${g},${b},${la})`);
        grad.addColorStop(0.45,`rgba(${r},${g},${b},${la * 0.7})`);
        grad.addColorStop(0.75,`rgba(${r},${g},${b},${la * 0.3})`);
        grad.addColorStop(1,   `rgba(${r},${g},${b},0)`);
        ctx.beginPath();
        ctx.arc(this.x, this.y, lr, 0, Math.PI * 2);
        ctx.fillStyle = grad;
        ctx.fill();
      }

      // ── Floating powder dust particles ──
      this.particles.forEach(p => {
        const showAt = p.dist / this.maxR;
        if (progress < showAt * 0.5) return;

        const px = this.x + Math.cos(p.angle) * p.dist + p.ox;
        const py = this.y + Math.sin(p.angle) * p.dist + p.oy;

        // tiny particle gradient for soft powder dot
        const pr = p.r * this.life;
        if (pr < 0.5) return;
        const pg = ctx.createRadialGradient(px, py, 0, px, py, pr * 2);
        pg.addColorStop(0,   `rgba(${r},${g},${b},${p.alpha * this.life})`);
        pg.addColorStop(1,   `rgba(${r},${g},${b},0)`);
        ctx.beginPath();
        ctx.arc(px, py, pr * 2, 0, Math.PI * 2);
        ctx.fillStyle = pg;
        ctx.fill();
      });

      ctx.restore();
    }

    get dead() { return this.life <= 0; }
  }

  /* ─────────────────────────────────────────
     PowderStream — thrown arc of powder
  ───────────────────────────────────────── */
  class PowderStream {
    constructor() {
      this.x     = Math.random() * canvas.width;
      this.y     = canvas.height * (0.2 + Math.random() * 0.6);
      this.color = COLORS[Math.floor(Math.random() * COLORS.length)];
      this.rgb   = hexRGB(this.color);

      const dir  = Math.random() > 0.5 ? 1 : -1;
      this.vx    = dir * (3 + Math.random() * 5);
      this.vy    = -(2 + Math.random() * 4);
      this.gravity = 0.12;

      this.dots  = [];
      this.life  = 1;
      this.decay = 0.014 + Math.random() * 0.01;
      this.emitting = true;
      this.age   = 0;
      this.maxAge = 30 + Math.random() * 30;
    }

    update() {
      this.age++;
      if (this.age > this.maxAge) this.emitting = false;

      this.vx *= 0.97;
      this.vy += this.gravity;
      this.x  += this.vx;
      this.y  += this.vy;

      if (this.emitting) {
        for (let i = 0; i < 3; i++) {
          this.dots.push({
            x: this.x + (Math.random()-0.5)*8,
            y: this.y + (Math.random()-0.5)*8,
            r: 2 + Math.random() * 5,
            vx: (Math.random()-0.5)*1.5,
            vy: -(Math.random()*1),
            life: 0.7 + Math.random() * 0.3,
            decay: 0.012 + Math.random() * 0.01,
          });
        }
      }

      this.dots.forEach(d => {
        d.x    += d.vx;
        d.y    += d.vy;
        d.vy   += 0.04;
        d.life -= d.decay;
      });
      this.dots = this.dots.filter(d => d.life > 0);

      if (!this.emitting && this.dots.length === 0) this.life = 0;
    }

    draw() {
      const [r, g, b] = this.rgb;
      this.dots.forEach(d => {
        const pg = ctx.createRadialGradient(d.x, d.y, 0, d.x, d.y, d.r * 2.5);
        pg.addColorStop(0,  `rgba(${r},${g},${b},${d.life * 0.65})`);
        pg.addColorStop(0.5,`rgba(${r},${g},${b},${d.life * 0.35})`);
        pg.addColorStop(1,  `rgba(${r},${g},${b},0)`);
        ctx.beginPath();
        ctx.arc(d.x, d.y, d.r * 2.5, 0, Math.PI * 2);
        ctx.fillStyle = pg;
        ctx.fill();
      });
    }

    get dead() { return this.life <= 0 && this.dots.length === 0; }
  }

  /* ── Spawn & loop ── */
  let effects   = [];
  let startTime = null;
  let spawning  = true;

  function spawnBurst()  { effects.push(new PowderBurst()); }
  function spawnStream() { effects.push(new PowderStream()); }

  // initial splashes
  for (let i = 0; i < 5; i++) setTimeout(spawnBurst, i * 100);
  for (let i = 0; i < 3; i++) setTimeout(spawnStream, 200 + i * 150);

  const spawnInterval = setInterval(() => {
    if (!spawning) return;
    spawnBurst();
    if (Math.random() > 0.45) spawnBurst();
    if (Math.random() > 0.6)  spawnStream();
  }, 320);

  function loop(ts) {
    if (!startTime) startTime = ts;
    const elapsed = ts - startTime;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    effects = effects.filter(e => !e.dead);
    effects.forEach(e => { e.update(); e.draw(); });

    if (elapsed < DURATION_MS) {
      requestAnimationFrame(loop);
    } else {
      spawning = false;
      clearInterval(spawnInterval);

      (function finish() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        effects = effects.filter(e => !e.dead);
        effects.forEach(e => { e.update(); e.draw(); });
        if (effects.length > 0) {
          requestAnimationFrame(finish);
        } else {
          canvas.style.opacity = '0';
          setTimeout(() => {
            canvas.remove();
            window.removeEventListener('resize', resize);
          }, 1800);
        }
      })();
    }
  }

  requestAnimationFrame(loop);
})();
